import { Link } from 'react-router-dom';

const contentLinks = [
  { label: '首页推荐', to: '/' },
  { label: '电影分类', to: '/category/movie' },
  { label: '电视剧分类', to: '/category/tv' },
  { label: '全站搜索', to: '/search' },
];

const genreLinks = [
  { label: '科幻 · 冒险', to: '/category/movie' },
  { label: '悬疑 · 犯罪', to: '/category/tv' },
  { label: '古装 · 剧情', to: '/category/tv' },
  { label: '青春 · 成长', to: '/category/movie' },
];

const friendlyLinks = [
  { label: '影视内容索引', to: '/search' },
  { label: '高清电影合集', to: '/category/movie' },
  { label: '热播剧集合集', to: '/category/tv' },
  { label: '站点简介', to: '/#about' },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-950 text-primary-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-play-fill text-xl" />
              </span>
              <span className="font-heading text-lg font-extrabold text-background-50">麻豆视频</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-primary-200">
              聚合电影与电视剧内容的影视门户，提供分类筛选、详情浏览与播放器界面演示，帮助观众更快找到想看的内容。
            </p>
            <p className="mt-4 text-xs leading-relaxed text-primary-300">
              本站为演示站点，不提供真实流媒体服务，所有片名、评分与演职人员均为虚构示例。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              <Link to="/" className="cursor-pointer transition-colors hover:text-accent-300">
                内容导航
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {contentLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="cursor-pointer text-primary-200 transition-colors hover:text-accent-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              <Link to="/category/movie" className="cursor-pointer transition-colors hover:text-accent-300">
                热门分类
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {genreLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="cursor-pointer text-primary-200 transition-colors hover:text-accent-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              <Link to="/#about" className="cursor-pointer transition-colors hover:text-accent-300">
                友情链接
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {friendlyLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="cursor-pointer text-primary-200 transition-colors hover:text-accent-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-primary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2025 麻豆视频 · 演示站点，仅供内容展示与功能体验</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>内容均为虚构示例</span>
            <span className="hidden sm:inline">·</span>
            <span>不接入真实视频源</span>
          </p>
        </div>
      </div>
    </footer>
  );
}